import { render } from "./LaputaFooter.vue?vue&type=template&id=f2ae44e4&scoped=true"
import script from "./LaputaFooter.vue?vue&type=script&lang=js"
export * from "./LaputaFooter.vue?vue&type=script&lang=js"

import "./LaputaFooter.vue?vue&type=style&index=0&id=f2ae44e4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f2ae44e4"]])

export default __exports__